import { Divider, Modal } from '@mantine/core';
import { useUnit } from 'effector-react';
import { viewerModel } from 'entities/viewer/model';
import { USER_ROLES } from 'shared/api';
import { LanguageRadioGroup } from 'shared/ui';
import {
	ViewerMenuAvatar,
	ViewerMenuName,
	ViewerMenuRole,
	ViewerMenuButton,
	ViewerMenuAccountLink,
	ViewerMenuLogoutButton,
	ViewerMenuProfileLink,
} from './viewer-menu-menu';
import cls from './viewer-menu.module.scss';

export const ViewerMenuModal = () => {
	const { active, disable } = useUnit(viewerModel.switcher);
	const role = useUnit(viewerModel.$role);

	return (
		<>
			<ViewerMenuButton />
			<Modal.Root
				size={320}
				opened={active}
				onClose={disable}
			>
				<Modal.Overlay />
				<Modal.Content>
					<Modal.Header className={cls.viewerMenuHeader}>
						<ViewerMenuAvatar />
						<div className={cls.viewerMenuInfo}>
							<ViewerMenuName />
							<ViewerMenuRole />
						</div>
						<Modal.CloseButton data-test-id='modal-close-button' />
					</Modal.Header>
					<Modal.Body className={cls.viewerMenuBody}>
						{role !== USER_ROLES.cashier && (
							<>
								<div className={cls.viewerMenuGroup}>
									<ViewerMenuAccountLink />
									<ViewerMenuProfileLink />
								</div>
								<Divider />
							</>
						)}
						<LanguageRadioGroup />
						<Divider />
						<div className={cls.viewerMenuGroup}>
							<ViewerMenuLogoutButton />
						</div>
					</Modal.Body>
				</Modal.Content>
			</Modal.Root>
		</>
	);
};
